import React from 'react';
import DL1 from '../requestTypes/DL1';
import DL2 from '../requestTypes/DL2';
import DL3 from '../requestTypes/DL3';
import DL4 from '../requestTypes/DL4';
import DL5 from '../requestTypes/DL5';
import DL13 from '../requestTypes/DL13';
import DL14 from '../requestTypes/DL14';
import GenericDL from '../requestTypes/GenericDL';

const Step4 = ({ formData, updateFormData }) => {
  // Dynamic component rendering based on request type
  const renderRequestTypeFields = () => {
    switch (formData.requestType) {
      case 'DL1':
        return <DL1 formData={formData} updateFormData={updateFormData} />;
      case 'DL2':
        return <DL2 formData={formData} updateFormData={updateFormData} />;
      case 'DL3':
        return <DL3 formData={formData} updateFormData={updateFormData} />;
      case 'DL4':
        return <DL4 formData={formData} updateFormData={updateFormData} />;
      case 'DL5':
        return <DL5 formData={formData} updateFormData={updateFormData} />;
      case 'DL6':
        return <GenericDL dlType="DL6" formData={formData} updateFormData={updateFormData} />;
      case 'DL7':
        return <GenericDL dlType="DL7" formData={formData} updateFormData={updateFormData} />;
      case 'DL8':
        return <GenericDL dlType="DL8" formData={formData} updateFormData={updateFormData} />;
      case 'DL9':
        return <GenericDL dlType="DL9" formData={formData} updateFormData={updateFormData} />;
      case 'DL10':
        return <GenericDL dlType="DL10" formData={formData} updateFormData={updateFormData} />;
      case 'DL11':
        return <GenericDL dlType="DL11" formData={formData} updateFormData={updateFormData} />;
      case 'DL12':
        return <GenericDL dlType="DL12" formData={formData} updateFormData={updateFormData} />;
      case 'DL13':
        return <DL13 formData={formData} updateFormData={updateFormData} />;
      case 'DL14':
        return <DL14 formData={formData} updateFormData={updateFormData} />;
      default:
        return (
          <div className="alert alert-info">
            Παρακαλώ επιλέξτε είδος αιτήματος στο προηγούμενο βήμα.
          </div>
        );
    }
  };

  return (
    <div>
      <h3>Βήμα 4: Στοιχεία Αιτήματος</h3>
      <p className="mb-20">
        Συμπληρώστε τα απαραίτητα στοιχεία για το είδος αιτήματος που επιλέξατε.
      </p>

      {renderRequestTypeFields()}

      <div className="alert alert-info" style={{ marginTop: '30px' }}>
        <strong>➡️ Επόμενο βήμα:</strong> Επιβεβαίωση και υποβολή του αιτήματός σας.
      </div>
    </div>
  );
};

export default Step4;




